// extracted by mini-css-extract-plugin
export default {"wrapper":"Face_style_wrapper__6IeIq","content":"Face_style_content__-wcYt","rotate":"Face_style_rotate__N15nW"};